import { useState } from 'react';
import BookableResourcesList from '../../../components/scheduling/BookableResourcesList.jsx';
import ResourceAvailability from '../../../components/scheduling/ResourceAvailability.jsx';
import Limits from '../../../components/scheduling/Limits.jsx';
import SidePanel from '../../../components/SidePanel.jsx';
import PencilSquareIcon from '../../../components/icons/PencilSquareIcon';
import RenameBookableResource from '../../../components/scheduling/RenameBookableResource.jsx';
import { shouldShowCapacity } from '../../../lib/BookableResourceHelpers.js';
import ShowTimezoneIfDifferent from '../../../components/scheduling/ShowTimezoneIfDifferent.jsx';
import FeatureIntro from '~/components/FeatureIntro.jsx';
import { useBusinessInfo } from '~/lib/Queries';
import PageHeading from '~/components/PageHeading';
import AssistantBanner from '~/components/assistant/AssistantBanner.jsx';

const AvailabilityPage = ({}) => {
    const { data: businessData } = useBusinessInfo();
    const [selectedResource, setSelectedResource] = useState();
    const [renameResource, setRenameResource] = useState(false);

    const isLimitedResources =
        !!businessData?.permissions?.isLimitedBookableResources;

    return (
        <div>
            <PageHeading
                heading="Availability"
            />
            <FeatureIntro>
                Set hours that you're available to accept appointments. Hours
                can be set for people/staff, or other bookable things — like
                renting lanes, selling seats, etc.
            </FeatureIntro>

            <AssistantBanner
                className="mb-6"
                description="Tell Breely's Assistant when and how you're available, and it'll set up your days, times, people, resources, and other availability settings for you."
                id="availability"
                prompt="Help me set up my availability."
            />

            <div className="flex w-full">
                <div className="lg:w-1/2 mb-6">
                    <BookableResourcesList
                        selected={selectedResource}
                        setSelected={setSelectedResource}
                        onClickEditName={resource => {
                            setRenameResource(resource);
                        }}
                        hideAddButton={isLimitedResources}
                    />

                    {!isLimitedResources && <Limits className="mt-6" />}
                </div>
                <div className="lg:w-1/2  lg:ml-4">
                    <SidePanel
                        isOpen={!!selectedResource}
                        onClose={() => setSelectedResource(null)}
                        title={
                            <>
                                <div
                                    className="flex text-xl items-center"
                                    onClick={() =>
                                        setRenameResource(selectedResource)
                                    }
                                >
                                    {selectedResource?.name}
                                    {shouldShowCapacity(selectedResource) && (
                                        <span className="ml-1">
                                            ({selectedResource?.capacity})
                                        </span>
                                    )}
                                    <button className="ml-3 btn-light-pill-sm uppercase">
                                        Edit
                                    </button>
                                </div>

                                <ShowTimezoneIfDifferent
                                    timezone={selectedResource?.timezone}
                                    className="text-gray-500 font-normal"
                                />
                            </>
                        }
                        widthClass="lg:w-[40vw]"
                    >
                        {selectedResource && (
                            <ResourceAvailability
                                key={selectedResource.id}
                                resource={selectedResource}
                            />
                        )}
                    </SidePanel>
                </div>
            </div>

            <RenameBookableResource
                isOpen={!!renameResource}
                onClose={() => setRenameResource(null)}
                resource={renameResource}
            />
        </div>
    );
};

export default AvailabilityPage;
